import React, { Component } from 'react';



class mugong extends Component {
    // state = {

    // }
    // handleChange = (e) => {
    //     console.log(e);
    // }
    // handleSubmit = (e) => {
    //     console.log(e);
    // }
    render() {
  

        return (
            <section>

            <section className="container section" id="tabs">
            <div className="scrollspy" id="top">
            <div className="row">
                {/* <div className="col s12 l4">
                <h2 className="indigo-text text-darken-4">Travel</h2>
                </div> */}
                <div className="col s12 l8 offset-l2">
                <ul className="tabs">
                    <li className="tab col s3">
                    <a href="#mugong1" className="black-text">Biplane</a>
                    </li>
                    <li className="tab col s3">
                    <a href="#mugong2" className="active black-text">Step Stool</a>
                    </li>
                    <li className="tab col s3">
                    <a href="#mugong3" className="black-text">Box</a>
                    </li>
                    <li className="tab col s3">
                    <a href="#mugong4" className="black-text">Others</a>
                    </li>
                </ul>
                </div>
            </div>
            </div>
            </section>

            <section className="container section" id="mugong1">
                <h4 className="title">Project</h4>
                    <img src="../img31/1.jpg" width="420" height="300" alt="" className="responsive-img materialboxed"></img>
                <h4 className="title">Design</h4>
                    <img src="../img31/2.jpg" width="420" height="300" alt="" className="responsive-img materialboxed"></img>
                <h4 className="title">Report</h4>
                <div className="row">
        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img31/3.jpg" alt="" className="responsive-img materialboxed"/>
            </div>
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img31/4.jpg" alt="" className="responsive-img materialboxed"/>
            </div>
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img31/5.jpg" alt="" className="responsive-img materialboxed"/>
            </div>
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img31/6.jpg" alt="" className="responsive-img materialboxed"/>
            </div>
            </div>
        </div>
        </div>

        <div className="row">
        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img31/7.jpg" alt="" className="responsive-img materialboxed"/>
            </div>
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img31/8.jpg" alt="" className="responsive-img materialboxed"/>
            </div>
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img31/9.jpg" alt="" className="responsive-img materialboxed"/>
            </div>
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img31/10.jpg" alt="" className="responsive-img materialboxed"/>
            </div>
            </div>
        </div>
        </div>

            </section>   

            <section className="container section" id="mugong2">
                <h4 className="title">Project</h4> 
                    <div className="row">
                        <div className="col s12 m6 l6">
                            <img src="../img31/11.jpg" width="420" height="300" alt="" className="responsive-img materialboxed"></img>
                        </div>
                        <div className="col s12 m6 l6">
                            <img src="../img31/12.jpg" width="420" height="300" alt="" className="responsive-img materialboxed"></img>
                        </div>
                    </div>

                <h4 className="title">Design</h4>
                    <img src="../img31/13.jpg" width="420" height="300" alt="" className="responsive-img materialboxed"></img>
                <h4 className="title">Report</h4>
                <div className="row">
        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img31/14.jpg" alt="" className="responsive-img materialboxed"/>
            </div>
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img31/15.jpg" alt="" className="responsive-img materialboxed"/>
            </div>
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img31/16.jpg" alt="" className="responsive-img materialboxed"/>
            </div>
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img31/17.jpg" alt="" className="responsive-img materialboxed"/>
            </div>
            </div>
        </div>
        </div>

        <div className="row">
        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img31/18.jpg" alt="" className="responsive-img materialboxed"/>
            </div>
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img31/19.jpg" alt="" className="responsive-img materialboxed"/>
            </div>
            </div>
        </div>


        </div>

            </section>   


            <section className="container section" id="mugong3">
                <h4 className="title">Project</h4> 
                    <img src="../img31/20.jpg" width="420" height="300" alt="" className="responsive-img materialboxed"></img>
                <h4 className="title">Design</h4>
                    <img src="../img31/21.jpg" width="420" height="300" alt="" className="responsive-img materialboxed"></img>
                <h4 className="title">Report</h4>
                <div className="row">
        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img31/22.jpg" alt="" className="responsive-img materialboxed"/>
            </div>
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img31/23.jpg" alt="" className="responsive-img materialboxed"/>
            </div>
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img31/24.jpg" alt="" className="responsive-img materialboxed"/>
            </div>
            </div>
        </div>

        </div>

     </section>   


            <section className="container section" id="mugong4">
            <div className="row">
        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img31/25.jpg" alt="" className="responsive-img materialboxed"/>
            </div>
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img31/26.jpg" alt="" className="responsive-img materialboxed"/>
            </div>
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img31/27.jpg" alt="" className="responsive-img materialboxed"/>
            </div>
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img31/28.jpg" alt="" className="responsive-img materialboxed"/>
            </div>
            </div>
        </div>
        </div>


            </section>   
  
         </section>
            
        )
    }
}



export default mugong;